(function () {
  function DIUsers() {
    "use strict";
    var context = this;
    var mainScope = window.DI;
    context.name = "Users";
    context.init = function () {
      context.endpoint = window.DI.CompanyStatic.ApiMethod;
      mainScope.DI.subscribeDOMLoaded(function () {
      });
      context.webAlias.init();
    };
    context.webAlias = {
      init: function init() {
        var urlParams = {};
        var paramsToSend = {};

        if (window.location.search.length > 0) {
          urlParams = mainScope.CompanyUtil.parseUrlParams(window.location.search);
        }

        if (typeof urlParams.referral == "string" && urlParams.referral.length > 0) {
          paramsToSend.referral = urlParams.referral || "OlivedaOrphan";
        }

        if (typeof urlParams.type == "string" && urlParams.type.length > 0) {
          paramsToSend.type = urlParams.type || 2;
          sessionStorage.setItem('customerType', parseInt(paramsToSend.type, 10));
          window.AssociateType = parseInt(paramsToSend.type, 10);
        } else {
          if (sessionStorage.getItem('customerType') == null || sessionStorage.getItem('customerType') == 0) {
            sessionStorage.setItem('customerType', 1);
          }
        }
        console.log('GetCustomerSite');

        $.ajax({
          url: "https://casync.connectolive.com/getWebsite/" + (paramsToSend.referral || window.localStorage.getItem('ALS') || window.ALS || ""),
          type: "GET",
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          // data: paramsToSend.referral,
          success: function (response) {
            if (response) {
              var data = response.Data;
              if (typeof urlParams.type == "string" && urlParams.type.length > 0) {
                window.AssociateType = parseInt(paramsToSend.type, 10);
              }
              var customerType = window.AssociateType > 0 ? window.AssociateType : sessionStorage.getItem('customerType');
              console.log("customerType", customerType);
              if (window.ALS || paramsToSend.referral) {
                window.localStorage.setItem('ALS', (paramsToSend.referral || window.ALS || "OlivedaOrphan"));
              }
              var PriceType = "Retail";
              switch (parseInt(customerType, 10)) {
                case 2:
                case 7:
                  PriceType = "Retail";
                  break;
                case 1:
                case 4:
                case 5:
                  PriceType = "Wholesale";
                  break;
                case 3:
                case 6:
                  PriceType = "Corporate";
                  break;
                default:
                  PriceType = "Retail";
              }
              console.log("PriceType", PriceType);
              window.localStorage.setItem('enrollerinfo', JSON.stringify(response.Data));
              try {
                var rootScope = angular.element(document.body).injector() && angular.element(document.body).injector().get('$rootScope');
                if(rootScope){
                  rootScope.EnrollerInfo = JSON.parse(localStorage.getItem('enrollerinfo'));
                  rootScope.$apply();
                }
              } catch (error) {
              }
            }
          },
          error: function (error) {
          }
        });
      },
      setPriceType: function setPriceType(priceType) {
        var request = new XMLHttpRequest();
        request.open("POST", "/cart/update.js", true);
        request.withCredentials = true;
        request.setRequestHeader("Content-Type", "application/json");

        request.onreadystatechange = function () {
          if (request.readyState === 4) {
            try {
              var resp = JSON.parse(request.response);
            } catch (e) {
              console.error("Failed adding country selection to attributes!");
            }
          }
        };
        var updateCartRequest = {
          attributes: {
            priceType: priceType || 2
          }
        };
        if (window.location.pathname.indexOf('/pages/thank-you') > -1) {
          updateCartRequest.items = [];
        }
        request.send(JSON.stringify(updateCartRequest));
      },
      apply: function apply(info) {

      }
    };

    context.account = {
      CreateCustomer: function CreateCustomer() {
        var form = document.querySelector("#create_customer");
        var data = mainScope.CompanyUtil.collectFormData(form);
        var endpoint = context.endpoint["Customer"]["CreateCustomer"];
        var metafields = {
          "birthDate": "",
          "Gender": "",
          "webAlias": data['customer[replicate_url]'],
          "associateType": 1,
          "taxID": "",
          "Password": data['customer[password]'],
          "companyName": "",
          "textPhone": data['customer[phone]'],
          "userName": data['customer[replicate_url]'],
          "languageCode": "en",
          "sponsorId": $rootScope.EnrollerInfo.AssociateID
        };
        var request = {
          "customer": {
            "AcceptsMarketing": true,
            "Addresses": [
              {
                "Address1": data['customer[street1]'],
                "Address2": data['customer[street2]'],
                "City": data['customer[county]'],
                "Company": "",
                "Country": data['customer[country]'],
                "CountryCode": data['customer[country]'],
                "CountryName": data['customer[country]'],
                "Default": true,
                "FirstName": data['customer[first_name]'],
                "LastName": data['customer[last_name]'],
                "Name": data['customer[first_name]'] + data['customer[last_name]'],
                "Phone": data['customer[phone]'],
                "Province": data['customer[state]'],
                "ProvinceCode": data['customer[last_name]'],
                "Zip": data['customer[postal_code]']
              }
            ],
            "CreatedAt": new Date(),
            "Currency": "USD",
            "DefaultAddress": {
              "Address1": data['customer[street1]'],
              "Address2": data['customer[street2]'],
              "City": data['customer[county]'],
              "Company": "",
              "Country": data['customer[country]'],
              "CountryCode": data['customer[country]'],
              "CountryName": data['customer[country]'],
              "Default": true,
              "FirstName": data['customer[first_name]'],
              "LastName": data['customer[last_name]'],
              "Name": data['customer[first_name]'] + data['customer[last_name]'],
              "Phone": data['customer[phone]'],
              "Province": data['customer[state]'],
              "ProvinceCode": data['customer[state]'],
              "Zip": data['customer[postal_code]']
            },
            "Email": data['customer[email]'],
            "FirstName": data['customer[first_name]'],
            "LastName": data['customer[last_name]'],
            "Phone": data['customer[phone]'],
            "State": data['customer[state]'],
            "VerifiedEmail": false,
            "Metafields": [
              {
                "Key": "Customer",
                "Value": JSON.stringify(metafields),
                "ValueType": "json_string",
                "Namespace": "ProviderFields",
                "OwnerResource": "customers"
              }
            ]
          },
          "Metafields": [
            {
              "Key": "Customer",
              "Value": JSON.stringify(metafields),
              "ValueType": "json_string",
              "Namespace": "ProviderFields",
              "OwnerResource": "customers"
            }
          ],
          "options": {
            "Password": data['customer[password]'],
            "password_confirmation": data['customer[password]'],
            "SendEmailInvite": true,
            "SendWelcomeEmail": true
          }
        };
        $.ajax({
          url: endpoint,
          type: "POST",
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          data: paramsToSend,
          success: function (response) {
            if (response.status === 200) {
              document.getElementById("create_customer").reset();
              response = JSON.parse(response.responseText);
              //mainScope.General.notifications.showNotification(1, "Success", "Account created!");
              mainScope.Users.webAlias.init();
              setTimeout(function () {
                var urlParams = {};
                if (window.location.search.length > 0) {
                  urlParams = mainScope.CompanyUtil.parseUrlParams(window.location.search);
                }
                if (urlParams.hasOwnProperty("redirect")) {
                  window.location.href = decodeURIComponent(urlParams.redirect);
                } else {
                  var redirectURL = window.location.origin + mainScope.Static.sitePages.account;
                  if (response.data.siteOwner && response.data.siteOwner.alias) {
                    redirectURL += "&referral=" + response.data.siteOwner.alias;
                  }
                  window.location.href = redirectURL;
                }
              }, 1500);
            } else {
              console.log(2, "Error", response.message);
            }
            context.actions.enableElement(trigger);

          },
          error: function (error) {

          }
        });
      },
      getAccountData: function getAccountData() {
        var account = document.querySelector(".st-bds_account-content-area");
        if (account !== null) {
          $.ajax({
            url: context.endpoint["customer"]["GetCustomer"],
            type: "POST",
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            data: {
              "customerId": "5290891411618"
            },
            success: function (response) {
              if (response.status === 200) {
                response = JSON.parse(response.response);
                context.account.renderAccountData(response, target);
              } else {
                console.log(2, "Error", response.message);
              }
            },
            error: function (error) {
            }
          });
        }
      },

    };
    context.findenroller = function findenroller(searchtext) {
      return $.ajax({
        url: context.endpoint["Customer"]["FindEnroller"],
        type: "POST",
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify({
          "SearchTerm": searchtext,
          "IncludeCustomers": true,
          "StatusIds": 1
        })
      });
    };
    context.getcustomersitebyid = function getcustomersitebyid(id) {

      return $.ajax({
        url: "https://casync.connectolive.com/getWebsiteParms/id/" + id,
        type: "GET",
        dataType: "json",
        contentType: "application/json; charset=utf-8"
      });
    };
    return this;
  };
  var DIUsersInstance = new DIUsers();
  window.DIMainInstance.injectReference(DIUsersInstance.name, DIUsersInstance);
  DIUsersInstance.init();
})();